module.exports = __webpack_public_path__ + "static/media/air_quality.0c1db187.png";